<template>
    <div class="vue-marker-details">
        <h2 class="virtual-h3 mb-1">{{ marker.title }}</h2>
        <p class="mb-3 mb-md-5" v-if="marker.coming_soon">Coming Soon</p>

        <div class="info">
            <div class="contact">
                <div class="mb-3 mb-md-5">
                    {{ marker.streetNumber }}<br>
                    {{ marker.postalCodePlace }}
                </div>

                <div class="d-flex flex-column">
                    <template v-if="marker.tel">
                        <a :href="`tel:${parsedPhonenumber}`">{{ marker.tel }}</a>
                    </template>

                    <template v-if="marker.email">
                        <a :href="'mailto:'+marker.email">{{ marker.email }}</a>
                    </template>
                </div>
            </div>
        </div>

        <a :href="marker.url" class="btn btn-primary">{{ moreInformationText }} <span class="visually-hidden">{{ marker.title }}</span></a>
    </div>
</template>

<script>
import parsePhoneNumber from './../../../../../themes/custom/ef2_custom/node_modules/libphonenumber-js';

export default {
    name: "MarkerDetails",

    props: {
        marker: {
            type: Object,
            required: true
        },
    },

    data() {
        return {
            moreInformationText: window.Drupal.t('More information')
        }
    },

    mounted() {
        this.$emit('alive');
    },

    computed: {
        parsedPhonenumber() {
            if (_.isEmpty(this.marker.tel)) {
                return;
            }

            return parsePhoneNumber(this.marker.tel, 'US').number;
        },
    }
}
</script>
